const getEventDetail = (event) => {
  if (!event) {
    return null;
  }

  const {
    description,
    title: eventName,
    venue: location,
    venueId,
  } = event;

  return {
    description,
    eventName,
    location,
    venueId,
  };
};

const getTemplateDetail = (template, locale = 'en-us') => {
  if (!template) {
    return null;
  }

  const {
    image_dimensions: imageDimensions,
    is_event: isEvent,
    raw_image_names: rawImageNames,
    menu: {
      [locale]: itemMenu,
    },
    reservation_config: {
      type: itemName,
    },
    deposit_fee: price,
    venue_id: venueId,
  } = template;

  const r = {
    imageDimensions,
    isEvent,
    itemMenu,
    itemName,
    rawImageNames,
    venueId,
  };

  if (price) {
    r.itemPrice = price;
    r.price = price;
  }

  return r;
};

const getDetail = ({
  seats = 2,
  venueName,
  city,
  reservation,
  currencyCode = 'USD',
  locale = 'en-us',
  templates,
}) => {
  let template;
  if (reservation?.templateId) {
    template = templates[reservation.templateId];
  }

  const dayTime = reservation?.time?.split(' ');
  const day = dayTime ? dayTime[0] : undefined;
  const time = dayTime ? dayTime[1] : undefined;

  const {
    isGda,
    price,
    type: tableType,
  } = reservation;

  return {
    city,
    currencyCode,
    isGda,
    itemPrice: price,
    price,
    seats,
    tableType,
    timeslot: {
      day,
      time,
    },
    venue: venueName,
    ...getTemplateDetail(template, locale),
    ...getEventDetail(reservation?.event),
  };
};

export {
  getEventDetail,
  getDetail,
  getTemplateDetail,
};
